import {Pipe, PipeTransform} from '@angular/core';
import {AttributeItem} from 'src/app/users/_interfaces/users-admin';
import {QuestionConfig} from '../interfaces/process-config.interface';

@Pipe({
    name: 'questionAttribute'
})
export class QuestionAttributePipe implements PipeTransform {
    transform(
        questions: QuestionConfig[],
        attributes: AttributeItem[],
        removeHiddenQuestions: boolean = false,
        removeQuestionWithAttributes: boolean = false
    ): QuestionConfig[] {
        if (!questions || questions.length === 0) return [];
        if (!attributes || attributes.length === 0) return questions;
        if (removeQuestionWithAttributes) {
            questions = questions.filter(q => !q.attributes || q.attributes.length === 0);
        }
        const questionsToHide = questions.filter(question => {
            if (!question.attributes || question.attributes.length === 0) return false;
            const orAttributes = question.attributes.filter(attribute => attribute.anD_OR === 1);
            const andAttributes = question.attributes.filter(attribute => attribute.anD_OR === 0);
            const orAttributesMatch = orAttributes.some(attribute => attributes
                .some(attr => attr.id === attribute.attributeId)) || orAttributes.length === 0;
            const andAttributesMatch = andAttributes
                .every(attribute => attributes.some(attr => attr.id === attribute.attributeId)) || andAttributes.length === 0
            return !orAttributesMatch || !andAttributesMatch;
        });
        questionsToHide.forEach(question => question.hideQuestion = true)
        questionsToHide.forEach(question =>
            questions.forEach(q => {
                if (q.id === question.id) {
                    q.hideQuestion = true;
                }
            }));
        questions.forEach(question => {
            if (question.relatedQuestions.length !== 0) {
                question.relatedQuestions = question.relatedQuestions.filter(rq => {
                    return !questionsToHide.some(qth => qth.id === rq.questionId);
                });
            }
        });
        if (removeHiddenQuestions) {
            questions = questions.filter(q => !q.hideQuestion);
        }
        return questions;
    }
}
